import HotelPreOpening from './HotelPreOpening';

export default HotelPreOpening;
